export const STATUS = {
	new: 'Nová poptávka (zpracovat)',
	declined: 'Prohra',
	accepted: 'Výhra',
	alternative: 'Čekající nabídka (odeslaná nabídka)',
	cancelled: 'Zrušena',
	refused: 'Fuck off',
	refused_elsewhere: 'Řešeno jinde/Fuck off',
} as const

export const STATUS_STYLES: Record<keyof typeof STATUS, string> = {
	new: 'bg-[#f0f9ff] text-[#0086c9]',
	declined: 'bg-[#fff3f8] text-[#dd2590]',
	accepted: 'bg-green-50 text-green-700',
	alternative: 'bg-yellow-100 text-yellow-700',
	cancelled: 'bg-gray-100 text-gray-600',
	refused: 'bg-gray-100 text-purple-600',
	refused_elsewhere: 'bg-purple-100 text-purple-800',
}

export const STATUS_OPTIONS = Object.entries(STATUS).map(([value, label]) => ({
	value,
	label,
}))
